import { render, staticRenderFns } from "./CartLayout.vue?vue&type=template&id=a5faefd4&scoped=true&"
import script from "./CartLayout.vue?vue&type=script&lang=js&"
export * from "./CartLayout.vue?vue&type=script&lang=js&"
import style0 from "./CartLayout.vue?vue&type=style&index=0&id=a5faefd4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5faefd4",
  null
  
)

export default component.exports